import { render, staticRenderFns } from "./ControleMerendaDia.vue?vue&type=template&id=2e2ca19d&scoped=true&"
import script from "./ControleMerendaDia.vue?vue&type=script&lang=js&"
export * from "./ControleMerendaDia.vue?vue&type=script&lang=js&"
import style0 from "./ControleMerendaDia.vue?vue&type=style&index=0&id=2e2ca19d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2ca19d",
  null
  
)

export default component.exports